import { Fab, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface ResponsiveFabProps {
  onClick: () => void;
  title: string;
  color?: 'primary' | 'secondary';
}

const ResponsiveFab: React.FC<ResponsiveFabProps> = ({
  onClick,
  title,
  color = 'primary'
}) => {
  return (
    <Fab
      color={color}
      aria-label={title}
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: { xs: '10%' },
        right: { xs: '5%', sm: '10%', md: '10%', lg: '8%', xl: '10%' },
        width: { xs: 75, sm: 90 },
        height: { xs: 75, sm: 90 }
      }}
    >
      <Tooltip title={title}>
        <AddIcon
          sx={{
            fontSize: { xs: 32, sm: 42 }
          }}
        />
      </Tooltip>
    </Fab>
  );
};

export default ResponsiveFab;
